import { Injectable, TemplateRef } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { AlertDialogComponent } from '@ui/components/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from '@ui/components/confirm-dialog/confirm-dialog.component';
import {
  AlertDialogData,
  DialogSize,
  ConfirmDialogData,
  DialogDimensions,
  InfoDialogData,
} from '@core/utils/dialog-utils';
import { InfoDialogComponent } from '@ui/components/info-dialog/info-dialog.component';
import { RemarksInputDialogComponent } from '@ui/components/remarks-input-dialog/remarks-input-dialog.component';

@Injectable()
export class DialogFactoryService {
  constructor(public matDialog: MatDialog) {}

  openAlert<R = any>(
    alert: AlertDialogData,
    config?: MatDialogConfig<AlertDialogData>
  ): MatDialogRef<AlertDialogComponent, R> {
    config = config || {};
    alert.title = alert.title || 'Alert';
    alert.okText = alert.okText || 'Dismiss';
    config.data = config.data || alert;
    return this.openSized(DialogSize.small, AlertDialogComponent, config);
  }

  openConfirmation<R = any>(
    confirm: ConfirmDialogData,
    config?: MatDialogConfig<ConfirmDialogData>
  ): MatDialogRef<ConfirmDialogComponent, R> {
    config = config || {};
    confirm.title = confirm.title || 'LBL.PLEASE_CONFIRM';
    confirm.okText = confirm.okText || 'BTN.BTN_OK';
    confirm.cancelText = confirm.cancelText || 'BTN.BTN_CANCEL';
    config.data = config.data || confirm;
    return this.openSized(DialogSize.small, ConfirmDialogComponent, config);
  }

  openInputConfirmation<R = any>(
    confirm: ConfirmDialogData,
    config?: MatDialogConfig<ConfirmDialogData>
  ): MatDialogRef<RemarksInputDialogComponent, R> {
    config = config || {};
    confirm.title = confirm.title || 'LBL.PLEASE_CONFIRM';
    confirm.okText = confirm.okText || 'BTN.BTN_OK';
    confirm.cancelText = confirm.cancelText || 'BTN.BTN_CANCEL';
    confirm.isRequired = confirm.isRequired || false;
    config.data = config.data || confirm;
    return this.openSized(
      DialogSize.small,
      RemarksInputDialogComponent,
      config
    );
  }

  openSized<T, D = any, R = any>(
    size: DialogDimensions,
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>
  ): MatDialogRef<T, R> {
    config = config || {};
    config.width = config.width || size.width;
    config.height = config.height || size.height;
    config.minWidth = config.minWidth || size.minWidth;
    config.minHeight = config.minHeight || size.minHeight;
    config.autoFocus = config.autoFocus || false;
    config.panelClass = ['kmt-dialog-container'];
    return this.matDialog.open(componentOrTemplateRef, config);
  }

  openInfo<R = any>(
    confirm: InfoDialogData,
    config?: MatDialogConfig<InfoDialogData>
  ): MatDialogRef<InfoDialogComponent, R> {
    config = config || {};
    confirm.title = confirm.title || 'LBL.INFO';
    confirm.okText = confirm.okText || 'BTN.BTN_OK';
    config.data = config.data || confirm;
    return this.openSized(DialogSize.small, InfoDialogComponent, config);
  }
}
